import React, { useState, useEffect } from "react";
import { ContactInfo } from "./Utils/CustomerLabelInput";
import { RiErrorWarningLine } from "react-icons/ri";
import Subscription from "./Subscription";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";
import { resetReducer } from "../../../store/reducers/digitalmarketing/branches";
import { useAddBranchMutation, useGetBranchByIdQuery, useGetBranchQuery, useUpdateBranchMutation } from "../../../Service/branches";
import { useNavigate, useParams } from "react-router-dom";
import { emailValidation, negativeNumberStringValidation, validatePhone } from "./Utils/validation";


function CustomerDetails(props) {
  const { refetch, setshow, show,cancel, branchEditId, branchDetail, setBranchDetail, openSnackBar } = props
  const [branch, setBranch] = useState(branchDetail)

  const [addBranch] = useAddBranchMutation()
  const [updateBranch] = useUpdateBranchMutation()
  const [error, setError] = useState(false)
  const [submit, setSubmit] = useState(false)
  const { id } = useParams()



  // const { data: branchDetails, isLoading: brannchLoading } = useGetBranchByIdQuery(branchEditId || "", { refetchOnMountOrArgChange: true });

  useEffect(() => {
    setBranch(branchDetail)
  }, [props])

  const save = async () => {
    setSubmit(true)
    const checking = Object.keys(branch).every((item) => {
      if (branch[item] !== '' && branch[item]) {
        if (branch[item].toString().trim().length) {
          if (item == 'emailId') {
            return emailValidation(branch[item])
          }
          if (item == 'mobileNo') {
            return validatePhone(branch[item])
          }
          if (item == 'branchName') {
            return branch[item].toString().trim().length > 3
          }
          if (item == 'pincode') {
            if (branch[item].toString().trim().length != 6 || !negativeNumberStringValidation(branch[item]))
              return false
            else
              return true
          }
          if (item == 'country' || item == 'city' || item == 'state') {
            return /^[a-zA-Z\s]+$/.test(branch[item])
          }
          else {
            return true
          }
        }
        else {
          return false
        }
      }
      else {
        if (branch[item] == null || branch[item] == undefined || branch[item].toString() == '0') {
          return true
        }
        return false
      }
    })


    if (checking) {
      setshow(!show)
      if (!branch.id) {
        try {
          const payload = await addBranch({ ...branch }).unwrap();
          openSnackBar("Successfully saved", "success")
        } catch (error) {
        }
      }
      else {
        await updateBranch({ id: branch.id, ...branch })
        openSnackBar("Successfully saved", "success")
      }

    }

  }
  const handleChangeInfo = (event) => {
    const { name, value } = event.target;
    setSubmit(false)
    setBranch((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const render = () => {
    return (<>
      <li className="d-flex">
        <div>
          <img src={require('../../../assets/DigitalMarketing/image/dummy_img.png')} alt="" width='70px'>
          </img>
        </div>
        <div> <input
          type="text"
          placeholder="Branch name"
          name="branchName"
          value={branch['branchName']}
          onChange={handleChangeInfo}
          className={`${submit && !(branch['branchName'].trim().length > 3) && "errorAlert"} text-custom-title mt-3`}
        /></div>
      </li>
      <li>
        <p className="title mt-2 mb-1">Contact information</p>
      </li>
      {ContactInfo.map((a, i) => (
        <li className="input-custom" key={i}>
          <a.tag
            branchDetail={branch}
            submit={submit}
            img={a.img}
            label={a.label}
            name={a.name}
            handleChange={handleChangeInfo}
          />
        </li>
      ))}
    
      <div className="d-flex justify-content-center">
        {cancel}
        <Button variant="contained" onClick={() => save()} id="btn-save">
          Save &#x2713;
        </Button>
      </div>
    </>)
  }

  return (
    <>
      {render()}
    </>
  );
}

export default React.memo(CustomerDetails);
